export default __webpack_public_path__ + "static/media/Scan 250.bbbc987b.jpg";